<template>
    <div class="hk-result comp">
        <div class="result-con">
            <div class="register-box">
                <div class="hk-message">
                    <img src="../../assets/img/hkcard.png" class="hk-card" />
                    <p class="register-text">
                        您已成功提交 {{ fundname }} {{ $util.fmtNum(amount) }}元购买申请
                        <br />
                        请在{{ $util.fmtDate(transactiondate) + " " + $util.fmtTime(closetime) }}
                        前汇款至以下账户，资金到账才能购买成功。
                    </p>
                </div>

                <div class="hk-class">
                    <div class="copy-set" v-on:click="copy(1)">一键复制</div>
                    <div class="card-info">
                        <div class="card-detail">
                            <span class="hk-title">银行户名：{{ hkinfo.acctname }}</span>
                            <span class="copy" v-on:click="copy(2)">复制</span>
                        </div>
                        <div class="card-detail">
                            <span class="hk-title">银行账号：{{ hkinfo.acctcode }}</span>
                            <span class="copy" v-on:click="copy(3)">复制</span>
                        </div>
                        <div class="card-detail">
                            <span class="hk-title">
                                <span style="white-space: nowrap">&nbsp;&nbsp;&nbsp;开户行：</span>
                                <span class="text-wrap">{{ hkinfo.bankname }}</span>
                            </span>
                            <span class="copy" v-on:click="copy(4)">复制</span>
                        </div>
                        <span id="message"></span>
                    </div>
                </div>
            </div>
        </div>
        <div class="result-buy-con">
            <el-row class="btn-group">
                <el-button type="primary" class="medium btn" v-on:click="goTo('traderecord')">
                    查看交易明细
                </el-button>
                <el-button type="null" class="medium btn btn-null" v-on:click="goTo('home')">
                    我的账户
                </el-button>
            </el-row>
        </div>
    </div>
</template>
<script>
import userApi from "@/api/user";
import fundApi from "@/api/fund";

export default {
    name: "HkResult",
    data() {
        return {
            fundname: "",
            amount: "",
            producttype: "",
            transactiondate: "",
            closetime: "",
            hkinfo: {}
        };
    },
    mounted() {
        this.fundname = this.$route.params.fundname;
        this.amount = this.$route.params.amount;
        this.producttype = this.$route.params.producttype;
        this.transactiondate = this.$route.params.transactiondate;
        // 路由参数缺失时按当前汇款规则兜底，避免查询汇款账户传空。
        this.paychannel = this.$route.params.paychannel || this.$util.getRemitTradePayChannel();
        this.queryBankAcct();
        this.qryTransDateInfo();
    },
    methods: {
        async qryTransDateInfo() {
            const res = await fundApi.qryTransDateInfo({
                fundcode: this.$route.params.fundcode,
                sharetype: this.$route.params.sharetype
            });
            this.closetime = res && res.data && res.data.closetime;
        },
        async queryBankAcct() {
            const { data } = await userApi.getInfoByPaychannel({
                paychannel: this.paychannel
            });
            if (data.cfgSpecacctinfoList || data.cfgFundSpecacctReqList) {
                // accttype 0-收款  1-付款 2-收付款
                let hkBankArray = [];
                if (this.producttype == "1") {
                    // 私募
                    hkBankArray = data.cfgFundSpecacctReqList.filter((item) => {
                        return item.accttype == "0" || item.accttype == "2";
                    });
                } else {
                    // 公募
                    hkBankArray = data.cfgSpecacctinfoList.filter((item) => {
                        return item.accttype == "0" || item.accttype == "2";
                    });
                }

                if (hkBankArray.length > 0) {
                    this.hkinfo = {
                        acctname: hkBankArray[0].acctname,
                        acctcode: hkBankArray[0].acctcode,
                        bankname: hkBankArray[0].bankname
                    };
                } else {
                    this.$message.info("未查询到汇款账户信息");
                }
            } else {
                this.$message.info("未查询到汇款账户信息");
            }
        },
        async copy(index) {
            let text = "";
            if (index == 1) {
                text =
                    this.hkinfo.acctname +
                    "\n" +
                    this.hkinfo.acctcode +
                    "\n" +
                    this.hkinfo.bankname;
            } else if (index == 2) {
                text = this.hkinfo.acctname;
            } else if (index == 3) {
                text = this.hkinfo.acctcode;
            } else if (index == 4) {
                text = this.hkinfo.bankname;
            }

            this.$util.copyText(this, text);
        },
        goTo(name) {
            this.$router.push({ name: name });
        }
    }
};
</script>
<style lang="scss">
.hk-result {
    text-align: center;
    margin-bottom: 20px;
    border: 1px solid #eeeeee;

    .register-box {
        padding: 100px 0 24px 0;

        .hk-message {
            display: flex;
            justify-content: center;

            .hk-card {
                height: 56px;
                margin-right: 5px;
            }
        }

        .register-text {
            color: $text-color2;
            font-size: $f20;
            line-height: 28px;
            font-weight: 500;
            text-align: left;
        }

        .hk-class {
            margin: 30px auto 0 auto;
            width: 555px;
            background: #fbfaf9;
            border-radius: 4px;

            .copy-set {
                color: #fb3617;
                text-align: center;
                margin: 0 37px;
                padding: 18px;
                border-bottom: 1px solid #e0e0e0;
                cursor: pointer;
            }

            .card-info {
                text-align: left;
                padding: 18px 66px;

                .hk-title {
                    color: #333333;
                    font-size: 16px;
                    display: flex;

                    .text-wrap {
                        display: inline-block;
                        word-break: break-word;
                        white-space: normal;
                        max-width: 100%;
                    }
                }

                .copy {
                    white-space: nowrap;
                    cursor: pointer;
                }

                .card-detail {
                    margin-bottom: 20px;
                    display: flex;
                    justify-content: space-between;
                    color: #fb3617;
                }
            }
        }
    }

    .btn-group {
        padding-bottom: 100px;

        .btn {
            margin: 0 40px;
        }

        .btn-null {
            border: 1px solid #fb3617;
            color: #fb3617;
        }
    }
}
</style>
